import { defineMessages } from 'react-intl';

const messages: {
	// ── Header ──────────────────────────────────────────────────────────────
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labsLozenge: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labsLozengeTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Describe input ─────────────────────────────────────────────────────
	describePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createDescribePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	describeSubmitLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Top-level option labels ────────────────────────────────────────────
	remixOptionChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixOptionDiagram: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixOptionInfographic: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixOptionVisualization: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Top-level option icon alts ─────────────────────────────────────────
	chartIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	diagramIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infographicIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	visualizationIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Top-level option tooltips ──────────────────────────────────────────
	chartTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	diagramTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infographicTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	visualizationTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Sub-type labels (charts) ───────────────────────────────────────────
	subTypeLineChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeAreaChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeBarChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeFunnelChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypePieChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeGanttChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Sub-type labels (diagrams) ─────────────────────────────────────────
	subTypeMindMap: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeFlowChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Sub-type labels (infographics) ─────────────────────────────────────
	subTypeModernStyle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeBoldStyle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeSketchStyle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeMinimalistStyle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Sub-type labels (visual aids) ──────────────────────────────────────
	subTypeFlipCard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeQuadrant: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeTreeMap: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeTimeline: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeGeographicalMap: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeOrgChart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subTypeImage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pageRemixSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixOptionSlides: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixOptionWhiteboard: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remixOptionDatabase: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	slidesIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whiteboardIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databaseIconAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	slidesTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	whiteboardTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	databaseTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Pick for me ────────────────────────────────────────────────────────
	pickForMe: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// ── Unused legacy keys kept for i18n backwards compat ──────────────────
	selectedContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// ── Header ──────────────────────────────────────────────────────────────
	heading: {
		id: 'malleable-ui-components.remix.heading',
		defaultMessage: 'Remix',
		description: 'Heading displayed at the top of the Remix overlay panel',
	},
	createHeading: {
		id: 'malleable-ui-components.remix.create-heading',
		defaultMessage: 'Create',
		description: 'Heading displayed at the top of the Create overlay panel',
	},
	subtitle: {
		id: 'malleable-ui-components.remix.subtitle',
		defaultMessage: 'View this content in a new form',
		description: 'Subtitle below the Create a remix heading',
	},
	labsLozenge: {
		id: 'malleable-ui-components.remix.labs-lozenge.updated',
		defaultMessage: 'Labs',
		description: 'Label for the Labs lozenge in the Remix overlay header',
	},
	labsLozengeTooltip: {
		id: 'malleable-ui-components.remix.option.lozenge-tooltip',
		defaultMessage: 'Beta: This feature is still in development.',
		description:
			'The text is shown in a tooltip when the user hovers over the Beta lozenge tag displayed next to the remix overlay feature, indicating the feature is still in development.',
	},
	remixIconAlt: {
		id: 'malleable-ui-components.remix.icon-alt',
		defaultMessage: 'Remix icon',
		description: 'Alt text for the decorative remix gradient icon in the overlay header',
	},

	// ── Describe input ─────────────────────────────────────────────────────
	describePlaceholder: {
		id: 'malleable-ui-components.remix.describe-placeholder',
		defaultMessage: 'Or describe your remix...',
		description: 'Placeholder for the remix description input field',
	},
	createDescribePlaceholder: {
		id: 'malleable-ui-components.remix.create-describe-placeholder',
		defaultMessage: 'Or create something else…',
		description: 'Placeholder for the create description input field',
	},
	describeSubmitLabel: {
		id: 'malleable-ui-components.remix.describe-submit-label',
		defaultMessage: 'Submit',
		description: 'Accessible label for the describe input submit button',
	},

	// ── Top-level option labels ────────────────────────────────────────────
	remixOptionChart: {
		id: 'malleable-ui-components.remix.option.chart',
		defaultMessage: 'Charts',
		description:
			'The text is shown as the label for the Charts option in the remix overlay panel, allowing users to transform their page content into a chart or graph visualization.',
	},
	remixOptionDiagram: {
		id: 'malleable-ui-components.remix.option.diagram',
		defaultMessage: 'Diagrams',
		description:
			'The text is shown as the label for the Diagrams option in the remix overlay panel, allowing users to transform their page content into a diagram showing relationships.',
	},
	remixOptionInfographic: {
		id: 'malleable-ui-components.remix.option.infographic',
		defaultMessage: 'Infographics',
		description:
			'The text is shown as the label for the Infographics option in the remix overlay panel, allowing users to transform their page content into a visual infographic.',
	},
	remixOptionVisualization: {
		id: 'malleable-ui-components.remix.option.visualization',
		defaultMessage: 'Visualizations',
		description: 'Label for the Visualizations remix option',
	},

	// ── Top-level option icon alts ─────────────────────────────────────────
	chartIconAlt: {
		id: 'malleable-ui-components.remix.option.chart-icon-alt',
		defaultMessage: 'Chart icon',
		description:
			'The text is used as the accessible alt text for the icon image representing the Chart option in the remix overlay panel.',
	},
	diagramIconAlt: {
		id: 'malleable-ui-components.remix.option.diagram-icon-alt',
		defaultMessage: 'Diagram icon',
		description:
			'The text is used as the accessible alt text for the icon image representing the Diagram option in the remix overlay panel.',
	},
	infographicIconAlt: {
		id: 'malleable-ui-components.remix.option.infographic-icon-alt',
		defaultMessage: 'Infographic icon',
		description: 'Alt text for the infographic option icon',
	},
	visualizationIconAlt: {
		id: 'malleable-ui-components.remix.option.visualization-icon-alt',
		defaultMessage: 'Visualization icon',
		description: 'Alt text for the visualization option icon',
	},

	// ── Top-level option tooltips ──────────────────────────────────────────
	chartTooltip: {
		id: 'malleable-ui-components.remix.option.chart-tooltip',
		defaultMessage: 'View your data as a chart or graph',
		description:
			'The text is shown in a tooltip when the user hovers over the Chart option in the remix overlay panel, describing what the Chart remix will do to the page content.',
	},
	diagramTooltip: {
		id: 'malleable-ui-components.remix.option.diagram-tooltip',
		defaultMessage: 'Show relationships with a diagram',
		description:
			'The text is shown in a tooltip when the user hovers over the Diagram option in the remix overlay panel, describing what the Diagram remix will do to the page content.',
	},
	infographicTooltip: {
		id: 'malleable-ui-components.remix.option.infographic-tooltip',
		defaultMessage: 'Summarize key points with an infographic',
		description: 'Tooltip for the Infographic remix option',
	},
	visualizationTooltip: {
		id: 'malleable-ui-components.remix.option.visualization-tooltip',
		defaultMessage: 'Bring your content to life with a bespoke visual',
		description: 'Tooltip for the Visualization remix option',
	},

	// ── Sub-type labels (charts) ───────────────────────────────────────────
	subTypeLineChart: {
		id: 'malleable-ui-components.remix.sub-type.line-chart',
		defaultMessage: 'Line chart',
		description: 'Sub-type label for a line chart within the Chart remix option',
	},
	subTypeAreaChart: {
		id: 'malleable-ui-components.remix.sub-type.area-chart',
		defaultMessage: 'Area chart',
		description: 'Sub-type label for an area chart within the Chart remix option',
	},
	subTypeBarChart: {
		id: 'malleable-ui-components.remix.sub-type.bar-chart',
		defaultMessage: 'Bar chart',
		description: 'Sub-type label for a bar chart within the Chart remix option',
	},
	subTypeFunnelChart: {
		id: 'malleable-ui-components.remix.sub-type.funnel-chart',
		defaultMessage: 'Funnel chart',
		description: 'Sub-type label for a funnel chart within the Chart remix option',
	},
	subTypePieChart: {
		id: 'malleable-ui-components.remix.sub-type.pie-chart',
		defaultMessage: 'Pie chart',
		description: 'Sub-type label for a pie chart within the Chart remix option',
	},
	subTypeGanttChart: {
		id: 'malleable-ui-components.remix.sub-type.gantt-chart',
		defaultMessage: 'Gantt chart',
		description: 'Sub-type label for a Gantt chart within the Chart remix option',
	},

	// ── Sub-type labels (diagrams) ─────────────────────────────────────────
	subTypeMindMap: {
		id: 'malleable-ui-components.remix.sub-type.mind-map',
		defaultMessage: 'Mindmap',
		description: 'Sub-type label for a mind map within the Diagram remix option',
	},
	subTypeFlowChart: {
		id: 'malleable-ui-components.remix.sub-type.flow-chart',
		defaultMessage: 'Flowchart',
		description: 'Sub-type label for a flowchart within the Diagram remix option',
	},

	// ── Sub-type labels (infographics) ─────────────────────────────────────
	subTypeModernStyle: {
		id: 'malleable-ui-components.remix.sub-type.modern-style',
		defaultMessage: 'Modern style',
		description: 'Sub-type label for modern style within the Infographic remix option',
	},
	subTypeBoldStyle: {
		id: 'malleable-ui-components.remix.sub-type.bold-style',
		defaultMessage: 'Bold style',
		description: 'Sub-type label for bold style within the Infographic remix option',
	},
	subTypeSketchStyle: {
		id: 'malleable-ui-components.remix.sub-type.sketch-style',
		defaultMessage: 'Sketch style',
		description: 'Sub-type label for sketch style within the Infographic remix option',
	},
	subTypeMinimalistStyle: {
		id: 'malleable-ui-components.remix.sub-type.minimalist-style',
		defaultMessage: 'Minimalist style',
		description: 'Sub-type label for minimalist style within the Infographic remix option',
	},

	// ── Sub-type labels (visual aids) ──────────────────────────────────────
	subTypeFlipCard: {
		id: 'malleable-ui-components.remix.sub-type.flip-card',
		defaultMessage: 'Flip card',
		description: 'Sub-type label for a flip card within the Visualization remix option',
	},
	subTypeQuadrant: {
		id: 'malleable-ui-components.remix.sub-type.quadrant',
		defaultMessage: 'Quadrant',
		description: 'Sub-type label for a quadrant within the Visualization remix option',
	},
	subTypeTreeMap: {
		id: 'malleable-ui-components.remix.sub-type.tree-map',
		defaultMessage: 'Tree map',
		description: 'Sub-type label for a tree map within the Visualization remix option',
	},
	subTypeTimeline: {
		id: 'malleable-ui-components.remix.sub-type.timeline',
		defaultMessage: 'Timeline',
		description: 'Sub-type label for a timeline within the Visualization remix option',
	},
	subTypeGeographicalMap: {
		id: 'malleable-ui-components.remix.sub-type.geographical-map',
		defaultMessage: 'Geographical map',
		description: 'Sub-type label for a geographical map within the Visualization remix option',
	},
	subTypeOrgChart: {
		id: 'malleable-ui-components.remix.sub-type.org-chart',
		defaultMessage: 'Org chart',
		description: 'Sub-type label for an org chart within the Visualization remix option',
	},
	subTypeImage: {
		id: 'malleable-ui-components.remix.sub-type.image',
		defaultMessage: 'Image',
		description: 'Sub-type label for an image within the Visualization remix option',
	},

	pageRemixSubtitle: {
		id: 'malleable-ui-components.remix.page-remix-subtitle',
		defaultMessage: 'Create content inspired by this work',
		description: 'Subtitle for the page-level Remix overlay panel',
	},
	remixOptionSlides: {
		id: 'malleable-ui-components.remix.option.slides',
		defaultMessage: 'Slides',
		description: 'Label for the Slides page-level remix option',
	},
	remixOptionWhiteboard: {
		id: 'malleable-ui-components.remix.option.whiteboard',
		defaultMessage: 'Whiteboard',
		description: 'Label for the Whiteboard page-level remix option',
	},
	remixOptionDatabase: {
		id: 'malleable-ui-components.remix.option.database',
		defaultMessage: 'Database',
		description: 'Label for the Database page-level remix option',
	},
	slidesIconAlt: {
		id: 'malleable-ui-components.remix.option.slides-icon-alt',
		defaultMessage: 'Slides icon',
		description:
			'The text is used as the accessible alt text for the icon image representing the Slides option in the remix overlay panel.',
	},
	whiteboardIconAlt: {
		id: 'malleable-ui-components.remix.option.whiteboard-icon-alt',
		defaultMessage: 'Whiteboard icon',
		description:
			'The text is used as the accessible alt text for the icon image representing the Whiteboard option in the remix overlay panel.',
	},
	databaseIconAlt: {
		id: 'malleable-ui-components.remix.option.database-icon-alt',
		defaultMessage: 'Database icon',
		description:
			'The text is used as the accessible alt text for the icon image representing the Database option in the remix overlay panel.',
	},
	slidesTooltip: {
		id: 'malleable-ui-components.remix.option.slides-tooltip',
		defaultMessage: 'Transform your page into a slide deck',
		description:
			'The text is shown in a tooltip when the user hovers over the Slides option in the remix overlay panel, describing that the remix will transform the page into a slide deck.',
	},
	whiteboardTooltip: {
		id: 'malleable-ui-components.remix.option.whiteboard-tooltip',
		defaultMessage: 'Visualize your page on a whiteboard',
		description:
			'The text is shown in a tooltip when the user hovers over the Whiteboard option in the remix overlay panel, describing that the remix will visualize the page content on a whiteboard.',
	},
	databaseTooltip: {
		id: 'malleable-ui-components.remix.option.database-tooltip',
		defaultMessage: 'Structure your page content as a database',
		description:
			'The text is shown in a tooltip when the user hovers over the Database option in the remix overlay panel, describing that the remix will structure the page content as a database.',
	},

	// ── Pick for me ────────────────────────────────────────────────────────
	pickForMe: {
		id: 'malleable-ui-components.remix.pick-for-me',
		defaultMessage: 'Pick for me',
		description:
			'Button label that lets Rovo automatically choose the best sub-type for the selected remix option',
	},

	// ── Unused legacy keys kept for i18n backwards compat ──────────────────
	selectedContent: {
		id: 'malleable-ui-components.remix.selected-content',
		defaultMessage: 'Selected content',
		description: 'Label shown above the displayed selected text content in the Remix overlay',
	},
	noContent: {
		id: 'malleable-ui-components.remix.no-content',
		defaultMessage: 'No content selected',
		description: 'Fallback message displayed when no text content is currently selected',
	},
});

export default messages;
